import React, { useState, ReactElement, useEffect, useRef } from "react";
import { TextField, Button, Grid, Container, Typography, Card, CardActionArea, CardMedia, CardContent, Box, Tab, Tabs } from "@mui/material";
import {
    FormContainer,
    QuestionField,
    InputField,
    ButtonContainer,
    NextButton,
    BackButton,
    DomainHeader,
    QuestionContainer,
    Question,
    FormatLabel,
    FormatSelect,
    DomainTab,
    DomainTabs,
    DomainContainer,
    DomainContainerActive,
    ProgressMessage,
    DownloadButton,
    HeaderContainer,
    Divider,
    OfflineDownloadContainer,
    OfflineDownloadQuestion
} from "./ctepDynamicForm.styled"
import DynamicQuestionField from "./dynamicQuestionField";
import { updateEvents } from "modules/ac2/store/alert";
import { ReactComponent as CompleteIcon } from "assets/images/complete.svg";
import { ReactComponent as InProgressIcon } from "assets/images/current.svg";
import { ReactComponent as PendingIcon } from "assets/images/incomplete.svg";

function CTEPDynamicForm(props) {
    const [pageNum, setPageNum] = useState(0);
    const [formData, setFormData] = useState({});
    const [downloadType, setDownloadType] = useState("Docx");
    const [naviOption, setNaviOption] = useState("Continue");
    const [naviSelect, setNaviSelect] = useState(0);
    const [completedDomains, setCompletedDomains] = useState(new Set(['']));

    function handleSubmit(event) {
        event.preventDefault()
        formatDataNext(event)
    }

    function formatDataNext(data) {
        let domain = Object.keys(props.questionList)[pageNum]
        let updatedObject = Object.assign({}, formData, { [domain]: {} });
        for (let i = 0; i < (data.target.length - 1 - (Object.keys(props.questionList).length)) / 6; i++) {
            let question = Object.keys(props.questionList[domain])[i];
            updatedObject[domain] = Object.assign({}, updatedObject[domain], { [question]: {} });
            for (let j = 0; j < 6; j++) {
                if (j < 3) {
                    if (data.target[(i * 6 + ((Object.keys(props.questionList).length)) + j)].checked) {
                        updatedObject[domain][question] = Object.assign({}, updatedObject[domain][question], { Response: data.target[(i * 6 + ((Object.keys(props.questionList).length) + j))].id });
                    }
                } else {
                    if (j === 3) {
                        updatedObject[domain][question] = Object.assign({}, updatedObject[domain][question], { Coverage: Number(data.target[(i * 6 + ((Object.keys(props.questionList).length) + j))].value) });
                    } else if (j === 4) {
                        updatedObject[domain][question] = Object.assign({}, updatedObject[domain][question], { Effectiveness: Number(data.target[(i * 6 + ((Object.keys(props.questionList).length) + j))].value) });
                    } else {
                        updatedObject[domain][question] = Object.assign({}, updatedObject[domain][question], { Remarks: data.target[(i * 6 + ((Object.keys(props.questionList).length) + j))].value });
                    }
                }
            }
        }
        completedDomains.add(domain)
        setFormData(Object.assign({}, formData, updatedObject));

        if (pageNum === Object.keys(props.questionList).length - 1 && naviOption !== "Domain") {

            if (Object.keys(updatedObject).length !== Object.keys(props.questionList).length) {
                alert("Please complete all domain sections before continuing")
            } else {
                props.onNextButtonClick(formData);
                props.handlePromptSubmit(updatedObject, downloadType)
            }
        }

        if (naviOption === "Domain") {
            setPageNum(Number(naviSelect))
        } else {
            nextButtonClick();
        }
    }

    useEffect(() => {
        setFormData(props.formData)
    }, [])

    const nextButtonClick = () => {
        if (pageNum !== Object.keys(props.questionList).length - 1) {
            const element = document.getElementById('domain');
            element?.scrollIntoView({ behavior: "smooth" })
            setPageNum(pageNum + 1)
        }
    }

    const prevButtonClick = () => {
        if (pageNum === 0) {
            props.onPrevButtonClick();
        } else {
            const element = document.getElementById('domain');
            element?.scrollIntoView({ behavior: "smooth" })
            setPageNum(pageNum - 1)
        }
    }

    const downloadTypeChange = (event) => {
        setDownloadType(event.target.value)
    };

    const navigateDomain = (event) => {
        setNaviOption('Domain')

        if (event.target.dataset.value) {
            setNaviSelect(event.target.dataset.value)
        } else if (event.target.value) {
            setNaviSelect(event.target.value)
        }
    }

    const navigateContinue = (event) => {
        setNaviOption('Continue')
    }

    const downloadReport = (event) => {
        props.handleDownloadOfflineReport();
    }

    return (
        <section id="domain">

            <QuestionContainer>
                <DomainTabs>
                    {Object.keys(props.questionList).map((item, index) => (
                        <div onClick={navigateDomain} data-value={index}>
                            {index === pageNum ?
                                <DomainContainerActive onClick={navigateDomain} data-value={index}>

                                    <DomainTab onClick={navigateDomain} name="navigation" type="submit" form="formQuestions" value={index}>
                                        <div onClick={navigateDomain} data-value={index} style={{ display: "flex" }}><InProgressIcon onClick={navigateDomain} data-value={index} style={{ position: "relative", right: "1em" }} />{index + 1}.</div>
                                        {item}
                                    </DomainTab>
                                </DomainContainerActive> :
                                <DomainContainer onClick={navigateDomain} data-value={index}>
                                    <DomainTab onClick={navigateDomain} name="navigation" type="submit" form="formQuestions" value={index}>
                                        <div onClick={navigateDomain} data-value={index} style={{ display: "flex" }}>
                                            {completedDomains.has(item) ?
                                                <CompleteIcon onClick={navigateDomain} data-value={index} style={{ position: "relative", right: ".5em" }} /> :
                                                <PendingIcon onClick={navigateDomain} data-value={index} style={{ position: "relative", right: ".5em" }} />}{index + 1}.
                                        </div>
                                        {item}
                                    </DomainTab>
                                </DomainContainer>}
                        </div>
                    ))}
                </DomainTabs>

                <ProgressMessage>Comments are optional, but the more detail we have the more robust a report we can generate.</ProgressMessage>

            </QuestionContainer>

            <QuestionContainer>
                <HeaderContainer>
                    <div style={{ width: "50%" }}>
                        <Question>Before we get started, what format would you like your report delivered in?</Question>
                        <FormatLabel>Format</FormatLabel>

                        <FormatSelect name="Download" id="Download" onChange={downloadTypeChange}>
                            <option value="Docx">Docx</option>
                            <option value="PDF">PDF</option>
                            <option value="Excel">Excel</option>
                        </FormatSelect>

                    </div>
                    <Divider></Divider>
                    <OfflineDownloadContainer>
                        <OfflineDownloadQuestion>Or if you prefer to fill out the form offline, please download the questionnaire below.</OfflineDownloadQuestion>
                        <DownloadButton onClick={downloadReport} name="download">Download Questionnaire</DownloadButton>
                    </OfflineDownloadContainer>
                </HeaderContainer>
            </QuestionContainer>

            <FormContainer id="formQuestions" onSubmit={handleSubmit}>
                <div>
                    {Object.keys(props.questionList).map((item, index) => (
                        <div>
                            {index === pageNum ? <DomainHeader>{item}</DomainHeader> : <div />}
                            {index === pageNum ?
                                Object.keys(props.questionList[item]).map((itemQuestion, index) => (
                                    <DynamicQuestionField data={formData} itemHeader={item} item={itemQuestion} index={index}></DynamicQuestionField>
                                )) : <div />}
                        </div>

                    ))}
                </div>
            </FormContainer>
            <ButtonContainer>
                <BackButton onClick={prevButtonClick}>Go Back</BackButton>
                <NextButton onClick={navigateContinue} name="continue" type="submit" form="formQuestions">Continue</NextButton>
            </ButtonContainer>
        </section>
    )

}

export default CTEPDynamicForm;